var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-row"},_vm._l((_vm.rowData),function(componentData,i){return _c('CardRowComponent',{key:i,attrs:{"componentData":componentData}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }